import { Avatar, Chip } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import StarIcon from '@mui/icons-material/Star';
import StarUnknown from '../../images/others/StarUnknown.png';
import StarSilver from '../../images/others/StarSilver.png';
import StarGold from '../../images/others/StarGold.png';
import StarEmerald from '../../images/others/StarEmerald.png';

export const StatusBars = [
      {state: 'Unknown', 
        show:<Chip avatar={<img alt="" src={StarUnknown} width={25} height={25}></img>} label="Без статуса" style={{backgroundColor:'#ffffff'}} sx={{marginLeft: 0, marginRight: 'auto', height:'27px'}}/>,
        chip:<Chip avatar={<img alt="" src={StarUnknown} width={25} height={25}></img>} label="Без статуса" style={{backgroundColor:'#ffffff', opacity: '0.6'}} sx={{marginLeft: 0, marginRight: 'auto', height:'27px'}}/>,
        small:<img alt="" src={StarUnknown} width={25} height={25}></img>,
        color:'#F0FFFF'
      },
      {state: 'Argent', 
        show:<Chip avatar={<img alt="" src={StarSilver} width={25} height={25}></img>} label="Серебрянный" style={{backgroundColor:'#ffffff'}} sx={{marginLeft: 0, marginRight: 'auto', height:'27px'}}/>,
        chip:<Chip avatar={<img alt="" src={StarSilver} width={25} height={25}></img>} label="Серебрянный" style={{backgroundColor:'#ffffff', opacity: '0.6'}} sx={{marginLeft: 0, marginRight: 'auto', height:'27px'}}/>,
        small:<img alt="" src={StarSilver} width={25} height={25}></img>,
        color:'#c0c0c0'
      },
      {state: 'Gold', 
        show:<Chip avatar={<img alt="" src={StarGold} width={25} height={25}></img>} label="Золотой" style={{backgroundColor:'#ffffff'}} sx={{marginLeft: 0, marginRight: 'auto', height:'27px'}}/>,
        chip:<Chip avatar={<img alt="" src={StarGold} width={25} height={25}></img>} label="Золотой" style={{backgroundColor:'#ffffff', opacity: '0.6'}} sx={{marginLeft: 0, marginRight: 'auto', height:'27px'}}/>,
        small:<img alt="" src={StarGold} width={25} height={25}></img>,
        color:'#ffd700'
      },
      {state: 'Emerald', 
        show:<Chip avatar={<img alt="" src={StarEmerald} width={25} height={25}></img>} label="Изумрудный" style={{backgroundColor:'#ffffff'}} sx={{marginLeft: 0, marginRight: 'auto', height:'27px'}}/>,
        chip:<Chip avatar={<img alt="" src={StarEmerald} width={25} height={25}></img>} label="Изумрудный" style={{backgroundColor:'#ffffff', opacity: '0.6'}} sx={{marginLeft: 0, marginRight: 'auto', height:'27px'}}/>,
        small:<img alt="" src={StarEmerald} width={25} height={25}></img>,
        color:'#50c878'
      }]

export const TimeStatus = [
    {state: 'warning', icon: <AccessTimeIcon sx={{width:30, height:30, marginLeft: 'auto', marginRight: 0, color:'#ff9900'}}/>},
    {state: 'ok', icon: <AccessTimeIcon sx={{width:30, height:30, marginLeft: 'auto', marginRight: 0, color:'#90EE90'}}/>},
    {state: 'allert', icon: <AccessTimeIcon sx={{width:30, height:30, marginLeft: 'auto', marginRight: 0, color:'#FF0000'}}/>}
  ]
